<ng-container *ngIf="kkmForm">
  <div class="notice">
    <tax-icon name="info"></tax-icon>
    <span data-qa="notice">{{ 'kkm.action.deregister.sign' | translate }}</span>
  </div>

  <div class="card" *ngIf="kkmForm && kkmForm.fields">
    <div class="block" data-qa-block="organization-info">
      <span class="block_title" translate data-qa="block-title">kkm.organisation.title</span>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="full-name-title">{{ 'organization.full.name' | translate }}</span>
        <span data-qa="full-name" translate>{{ kkmForm.fields.title }}</span>
      </div>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="iin-title">{{ 'organization.iin' | translate }}</span>
        <span data-qa="iin" translate>{{ kkmForm.fields.INN }}</span>
      </div>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="oked-title" translate>organization.oked</span>
        <span data-qa="oked" translate>{{ oked$ | async }}</span>
      </div>

      <hr class="greyline" />

      <div class="block" data-qa-block="kkm-info">
        <span class="block_title" data-qa="block-title" translate>kkm.info.title</span>

        <div class="ui-kit-layout-columns-2">
          <span data-qa="kkm-serial-number-title">{{
            'kkm.settings.serial.number' | translate
          }}</span>
          <span data-qa="kkm-serial-number" translate>{{ kkmForm.fields.kkmSerialNumber }}</span>
        </div>

        <div class="ui-kit-layout-columns-2">
          <span data-qa="kkm-model-title">{{ 'kkm.settings.model' | translate }}</span>
          <span data-qa="kkm-model" translate>{{ kkmForm.fields.kkmModel }}</span>
        </div>

        <div class="ui-kit-layout-columns-2">
          <span data-qa="kkm-year-title">{{ 'kkm.settings.year' | translate }}</span>
          <span data-qa="kkm-year" translate>{{ kkmForm.fields.kkmYear }}</span>
        </div>

        <div class="ui-kit-layout-columns-2">
          <span data-qa="retail-place-address-title">{{ 'retail.place.address' | translate }}</span>
          <span data-qa="retail-place-address" translate>{{
            kkmForm.fields.retailPlaceAddress?.fullAddress
          }}</span>
        </div>

        <div class="ui-kit-layout-columns-2">
          <span data-qa="kkm-rnm-title">{{ 'ticket.kkm.fns.kkm.id' | translate }}</span>
          <span data-qa="kkm-rnm" translate>{{ kkmForm.fields.kkmRegId }}</span>
        </div>

        <div class="ui-kit-layout-columns-2" *ngIf="selectedTariff$ | async as selectedTariff">
          <span data-qa="kkm-tariff-title">{{ 'tariffs.selected' | translate }}</span>
          <span data-qa="kkm-tariff" translate>{{ selectedTariff.name }}</span>
        </div>

        <div class="ui-kit-layout-columns-2">
          <span data-qa="deregister-reason-title">{{
            'kkm.action.deregister.reason' | translate
          }}</span>
          <span data-qa="deregister-reason" translate>{{ deregisterReason$ | async }}</span>
        </div>
      </div>
    </div>

    <div class="ui-kit-bottom-buttons-block">
      <button class="back-button" (click)="back()" data-qa-button="go-back">
        {{ 'group.back' | translate }}
      </button>
      <div>
        <button
          data-qa-button="sign-by-eds"
          *ngIf="data$ | async as data"
          class="button_blue"
          [taxOpenCertificateModal]="{ data }"
          (signatureGenerated)="setSignature($event, kkmForm)"
          translate
        >
          sign.by.eds.button
        </button>
        <button
          data-qa-button="sign-by-sms"
          *ngIf="kkmForm?.fields?.singBySmsAllowed === 'true'"
          class="button_blue"
          (click)="signBySms()"
          translate
        >
          sign.by.sms.button
        </button>
      </div>
    </div>
  </div>
</ng-container>
